






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Axios from 'axios';
import LoadingSpinner from '@components/012-LoadingSpinner/LoadingSpinner.vue';

@Component({
	components: {
		LoadingSpinner
	},
	hydration: true,
	componentId: 'M063'
})
export default class ExternalApp extends Vue {
	@Prop(String)
	protected readonly id!: string;

	protected async mounted(): Promise<void> {
		// Window location without anchor/deeplink
		let url = window.location.href.split('#')[0];

		// Use the current's page url, but add the parameter for loading the module (which has the id of the
		url += `${url.includes('?') ? '&' : '?'}loadModule=${this.id}`;

		const response = await Axios.get(url);

		// Extract html between <main></main>>
		const moduleContentMatches = response.data.match(/<main class="l-main">([\s\S]*?)<\/main>/m);

		if (moduleContentMatches && moduleContentMatches.length > 0) {
			this.$el.outerHTML = moduleContentMatches[1];
		} else {
			this.$el.outerHTML = response.data;
		}

		// Re-trigger hydration for newly added module
		document.dispatchEvent(new CustomEvent('DOMContentLoaded'));
	}
}
